import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_MULTI = '[BenutzerverwaltungModul] PostFunktionsbereichAdminEntfernenMulti laden';
export const POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_MULTI_AUSFUEHREN = '[BenutzerverwaltungModul] PostFunktionsbereichAdminEntfernenMulti ausführen';
export const POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_MULTI_ERFOLGREICH = '[BenutzerverwaltungModul] PostFunktionsbereichAdminEntfernenMulti laden erfolgreich';
export const POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_MULTI_FEHLER = '[BenutzerverwaltungModul] PostFunktionsbereichAdminEntfernenMulti Ladefehler';
export const POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_MULTI_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostFunktionsbereichAdminEntfernenMulti nicht ausgeführt (evtl. Offline)';


export class PostFunktionsbereichAdminEntfernenMultiAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_MULTI;
        constructor(public funktionsbereichBenutzerMultiRequest: api.FunktionsbereichBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichAdminEntfernenMultiAusfuehrenAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_MULTI_AUSFUEHREN;
        constructor(public funktionsbereichBenutzerMultiRequest: api.FunktionsbereichBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichAdminEntfernenMultiErfolgreichAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_MULTI_ERFOLGREICH;
        constructor(public payload: api.FunktionsbereichIdentifier, public funktionsbereichBenutzerMultiRequest: api.FunktionsbereichBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichAdminEntfernenMultiFehlerAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_MULTI_FEHLER;
        constructor(public payload: any, public funktionsbereichBenutzerMultiRequest: api.FunktionsbereichBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichAdminEntfernenMultiNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ADMIN_ENTFERNEN_MULTI_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandFunktionsbereichAdminEntfernenMultiActions =
    PostFunktionsbereichAdminEntfernenMultiAction
    | PostFunktionsbereichAdminEntfernenMultiAusfuehrenAction
    | PostFunktionsbereichAdminEntfernenMultiErfolgreichAction
    | PostFunktionsbereichAdminEntfernenMultiFehlerAction
    | PostFunktionsbereichAdminEntfernenMultiNichtAusgefuehrtAction
    ;
